/*!
* @bowencool/async-utilities v2.5.4
*/
class AbortError extends Error {}
AbortError.prototype.name = 'AbortError';
class TimeoutError extends Error {}
TimeoutError.prototype.name = 'TimeoutError';
function abortableAsync(fn, opt) {
  if (opt === void 0) {
    opt = {};
  }

  return function abortabledAsync() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new Promise((resolve, reject) => {
      var _opt$signal;

      let timer;
      let aborted = false; // avoid resolve when opt.alwaysPendingWhenAborted is true

      function doAbort() {
        // if (aborted) return;
        if (!opt.alwaysPendingWhenAborted) {
          reject(new AbortError('aborted'));
        }

        aborted = true;
        clearEffect();
      }

      (_opt$signal = opt.signal) == null ? void 0 : _opt$signal.addEventListener == null ? void 0 : _opt$signal.addEventListener('abort', doAbort);

      function doTimeout() {
        // if (aborted) return;
        if (!opt.alwaysPendingWhenAborted) {
          reject(new TimeoutError(`timeout of ${opt.timeout}ms`));
        }

        aborted = true;
        clearEffect();
      }

      if (typeof opt.timeout === 'number' && opt.timeout > 0) {
        timer = setTimeout(doTimeout, opt.timeout);
      }

      function clearEffect() {
        var _opt$signal2;

        if (typeof timer !== 'undefined') {
          clearTimeout(timer);
          timer = undefined;
        }

        (_opt$signal2 = opt.signal) == null ? void 0 : _opt$signal2.removeEventListener == null ? void 0 : _opt$signal2.removeEventListener('abort', doAbort);
      }

      fn.call(this, ...args).then(function () {
        if (!aborted) {
          resolve(...arguments);
        }

        clearEffect();
      }).catch(function () {
        if (!aborted) {
          reject(...arguments);
        }

        clearEffect();
      });
    });
  };
}

export { AbortError, TimeoutError, abortableAsync };
